export default __webpack_public_path__ + "static/media/cartow.88dd417f.png";